<div class="modal-header">
  <h4 class="modal-title">
    <fa-icon [icon]="faCreditCard" class="mr-2"></fa-icon>
    Choose Payment Option
  </h4>
  <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('cancel')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <div class="payment-options">
    <!-- Pay Current Balance Option -->
    <div class="payment-option mb-3" [class.disabled-option]="!hasBalanceDue">
      <button type="button"
              class="btn btn-outline-primary btn-lg w-100 payment-option-btn"
              [disabled]="!hasBalanceDue"
              (click)="selectPaymentOption('balance')">
        <div class="d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center">
            <fa-icon [icon]="faDollarSign" class="mr-3" size="2x"></fa-icon>
            <div class="text-left">
              <h5 class="mb-1">Pay Current Balance</h5>
              <p class="mb-0 text-muted">Pay your outstanding balance</p>
            </div>
          </div>
          <div class="amount-display">
            <span class="h4 mb-0" [class.text-muted]="!hasBalanceDue">
              {{ patientBalance | currency }}
            </span>
          </div>
        </div>
      </button>
      <small *ngIf="!hasBalanceDue" class="text-muted mt-1 d-block">
        No balance currently available
      </small>
    </div>

    <!-- Custom Amount Option -->
    <div class="payment-option">
      <button type="button"
              class="btn btn-outline-primary btn-lg w-100 payment-option-btn"
              (click)="selectPaymentOption('custom')">
        <div class="d-flex align-items-center">
          <fa-icon [icon]="faCreditCard" class="mr-3" size="2x"></fa-icon>
          <div class="text-left">
            <h5 class="mb-1">Enter Custom Amount</h5>
            <p class="mb-0 text-muted">Pay a specific amount of your choice</p>
          </div>
        </div>
      </button>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="modal.dismiss('cancel')">
    Cancel
  </button>
</div>